import React from "react";
import { countryCodeMapping, flagComponents } from "./constants";

const CountryFlagCircle = ({
  countryCode,
  className = "",
  style = {},
  title = null,
  size = 20,
  stretchX = 1.55,
  safeY = 0.92,
  background = "#fff",
}) => {
  if (!countryCode) return null;

  const normalizedCode = String(countryCode).toUpperCase();
  const twoLetterCode = countryCodeMapping[normalizedCode] || normalizedCode;
  const FlagComponent = flagComponents[twoLetterCode];

  if (!FlagComponent) {
    console.warn(`Country flag not found for code: ${countryCode}`);
    return null;
  }

  return (
    <div
      className={className}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
        borderRadius: "50%",
        overflow: "hidden",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        position: "relative",
        background,
        ...style,
      }}
    >
      <FlagComponent
        title={title || `${normalizedCode} flag`}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          height: `${size}px`,
          width: `${size * stretchX}px`,
          display: "block",
          transform: `translate(-50%, -50%) scaleY(${safeY})`,
          transformOrigin: "center",
          objectFit: "contain",
        }}
      />
    </div>
  );
};

export default CountryFlagCircle;
